import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";

export default {
	data() {
		return{
			isOpenMap: false,
			isOpenWindow: false,
			mapStyle: {
				styles:
					[
						{
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#f5f5f5"
								}
							]
						},
						{
							"elementType": "labels.icon",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"elementType": "labels.text",
							"stylers": [
								{
									"color": "#373737"
								},
								{
									"weight": 2.5
								}
							]
						},
						{
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#000000"
								}
							]
						},
						{
							"elementType": "labels.text.stroke",
							"stylers": [
								{
									"color": "#f5f5f5"
								},
								{
									"weight": 4.5
								}
							]
						},
						{
							"featureType": "administrative.land_parcel",
							"elementType": "labels",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "administrative.land_parcel",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#bdbdbd"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#eeeeee"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "labels.text",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#757575"
								}
							]
						},
						{
							"featureType": "poi.business",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "poi.park",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#e5e5e5"
								}
							]
						},
						{
							"featureType": "poi.park",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#9e9e9e"
								}
							]
						},
						{
							"featureType": "road",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#ffffff"
								}
							]
						},
						{
							"featureType": "road",
							"elementType": "labels.icon",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#000000"
								},
								{
									"weight": 1.5
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "geometry.stroke",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#757575"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#dadada"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#000000"
								},
								{
									"weight": 2
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry.stroke",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#616161"
								}
							]
						},
						{
							"featureType": "road.local",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#000000"
								},
								{
									"weight": 1
								}
							]
						},
						{
							"featureType": "road.local",
							"elementType": "geometry.stroke",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road.local",
							"elementType": "labels",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road.local",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#000000"
								}
							]
						},
						{
							"featureType": "transit",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "transit.line",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#e5e5e5"
								}
							]
						},
						{
							"featureType": "transit.station",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#eeeeee"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#c9c9c9"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#373737"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry.stroke",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#9e9e9e"
								}
							]
						}
					]
			},
			marker: null,
		}
	},
	props: [
		"title",
		"subTitle",
		"address",
		"location",
		"locationType",
		"image",
		"black"
	],
	created() {
		this.marker = {
			title: this.title,
			adress: this.address,
			position: {
				lat: Number(this.location.latitude),
				lng: Number(this.location.longitude)
			},
			markerIcon: this.getIcon(this.locationType),
		}
	},
	methods: {
		openMap() {
			this.isOpenMap = !this.isOpenMap
		},
		openWindow() {
			this.isOpenWindow = !this.isOpenWindow
		},
		getIcon(value) {
			if (value == "event")
				return { url: '../../static/icons/marker_black.png' };
			if (value == "sell")
				return { url: '../../static/icons/marker.png' };
			if (value == "head")
				return { url: '../../static/icons/marker_black.png' };
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/location-block/location.block.js